
interface Schema {
  id: string;
  tags: string;
  notes: string;
}

const LOCALSTORAGE_NAME = 'raidHelper';

export default class LocalStorage {

  private static _instance: LocalStorage;
  static get instance() {
    return this._instance || (this._instance = new this());
  }

  private _data: { [key:string]: Schema } = {};

  constructor() {
    this.read();
  }

  set(data: Schema) {
    this._data[data.id] = {
      id: data.id,
      tags: data.tags,
      notes: data.notes
    };
    console.log('Saved', data);
    this.save();
  }

  get(id: string) {
    return this._data[id];
  }

  getTags(id: string) {
    if (this._data && this._data.hasOwnProperty(id) && this._data[id].tags)
      return this._data[id].tags;
    return '';
  }

  getNotes(id: string) {
    if (this._data && this._data.hasOwnProperty(id) && this._data[id].notes)
      return this._data[id].notes;
    return ''
  }

  private save() {
    const str = JSON.stringify(this._data);
    localStorage.setItem(LOCALSTORAGE_NAME, str);
  }

  private read() {
    console.log(`Getting data`);
    const str = localStorage.getItem(LOCALSTORAGE_NAME);
    if (str) this._data = JSON.parse(str);
  }

}